module.exports = __webpack_public_path__ + "media/images/application/template/icon-download-439523adb0dfd5e36254bff772a4b241.svg";